<script setup>
import SelectBox from '@/components/shared/SelectBox.vue'
import JourneySurveyQuestion from '@/components/shared/JourneySurveyQuestion.vue'
import { useDataStore } from '@/stores/data'
import { autoCompleteSurveyForJourney } from '@/utils/journeyUtils'

const dataStore = useDataStore()

const props = defineProps({
	survey: {
		type: Object,
		default: {},
	},
})

const emit = defineEmits(['change', 'open'])

const optionsOpened = (isOpen) => {
	emit('open', isOpen)
}

console.warn('JourneySurveyQuestion: init', props.survey)

var didAutoComplete = autoCompleteSurveyForJourney(props.survey, dataStore.currentJourneyDay.autofill)
if (didAutoComplete) {
	emit('change', {
		survey: props.survey,
	})
}

const optionsSelected = (options) => {
	console.warn('JourneySurveyQuestion: optionsSelected', options)

	if (Array.isArray(options)) {
		clearOptionsSelected()
		options.forEach((option) => {
			if (option.code) props.survey.answerCode = option.code + ','
			if (option.value) props.survey.answerValue = option.value + ','
			handleOptionSelected(option)
		})
	} else {
		if (options.code) props.survey.answerCode = options.code
		if (options.value) props.survey.answerValue = options.value
		handleOptionSelected(options)
	}

	// Emit event with the selected option and survey data
	emit('change', {
		survey: props.survey,
		selectedOption: options,
	})
}

const clearOptionsSelected = () => {
	for (let i = 0; i < props.survey.options.length; i++) {
		props.survey.options[i].selected = false
	}
}

const handleOptionSelected = (option) => {
	// Set option as "selected" as true and set earlier options selected as false
	for (let i = 0; i < props.survey.options.length; i++) {
		props.survey.options[i].selected = props.survey.options[i].code === option.code
	}
	// If option has sub with only one option, set that that as selected as well, using optionsSelected
	if (option.sub && option.sub.options.length === 1) {
		option.sub.selected = true
		option.sub.answer = option.sub.options[0]
		if (option.sub.options[0].code) option.sub.answerCode = option.sub.options[0].code
		if (option.sub.options[0].value) option.sub.answerValue = option.sub.options[0].value
	}
}
</script>

<template>
	<div class="journey question mb-3">
		<label class="mb-2 mt-2">{{ survey.question }}</label>
		<div class="title">
			<select-box class="form purposes" :multiple="survey.type == 'checkbox'" style="width: 100%; white-space: normal" :nowrap="false" :options="survey.options" v-model="survey.answer" @open="optionsOpened" @change="optionsSelected">
				<template #selected-content>
					<div class="name">{{ survey.answer.name }}</div>
				</template>
				<template #selected-none>
					<span>Velg det som passer best for denne reisen</span>
				</template>
				<template #item="item">
					{{ item.option.name }}
				</template>
			</select-box>
		</div>
	</div>
	<template v-if="survey.answer && survey.answer.sub && survey.answer.sub.options.length > 1">
		<JourneySurveyQuestion :survey="survey.answer.sub" @open="optionsOpened" @change="$emit('change', $event)" />
	</template>
</template>

<style>
.journey.question {
	z-index: initial;
}
.journey.question .select-box {
	background: white url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"%3E%3Cpath fill="%236c757d" d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"/%3E%3C/svg%3E') right 0.75rem center/0.75rem no-repeat;
}
</style>
